/* eslint-disable semi,semi-style */
import { env, host, getSiteOrigin } from './env';

const setCookiePath = '/open-platform-web/api/index/setCookie';
const LOGIN_RETURN_KEY = 'epower_open_login_return';
const LOGIN_RESUME_FLAG = 'epower_open_should_resume';
/** 防止 Host/Remote 多个 10008 连续把 location 改去 passport */
const LOGIN_JUMP_LOCK = 'epower_open_login_jump_lock';
const LOGIN_JUMP_LOCK_AT = 'epower_open_login_jump_at';
const LOGIN_JUMP_LOCK_TTL_MS = 120000;
/** 登录回跳完成后的短暂窗口：忽略新的 Login()，避免 cookie 未就绪再跳一次 */
const LOGIN_GRACE_KEY = 'epower_open_login_grace_until';
const LOGIN_GRACE_MS = 8000;

/** 登录前记住 hash 路由；setCookie 回跳仍走 master 的 origin/#/ */
function saveLoginReturn() {
  const returnPath = `${location.pathname}${location.hash || ''}`;
  if (
    returnPath &&
    returnPath !== '/' &&
    returnPath !== '/index.html' &&
    returnPath !== '/index.html#/' &&
    location.hash
  ) {
    sessionStorage.setItem(LOGIN_RETURN_KEY, returnPath);
  }
}

/**
 * 与 master 一致：setCookie 只认站点 origin/#/（后端白名单）。
 * redirectUrl 用 getSiteOrigin 与 gw 环境配对，禁止改成 operate.html 等路径。
 */
function buildPassportRedirectUrl() {
  saveLoginReturn();
  sessionStorage.setItem(LOGIN_RESUME_FLAG, '1');
  const site = getSiteOrigin();
  return encodeURIComponent(`${host + setCookiePath}?url=${site}/#/`);
}

function clearJumpLock() {
  sessionStorage.removeItem(LOGIN_JUMP_LOCK);
  sessionStorage.removeItem(LOGIN_JUMP_LOCK_AT);
}

function hasActiveJumpLock() {
  if (sessionStorage.getItem(LOGIN_JUMP_LOCK) !== '1') return false;
  const at = Number(sessionStorage.getItem(LOGIN_JUMP_LOCK_AT) || 0);
  if (!at || Date.now() - at > LOGIN_JUMP_LOCK_TTL_MS) {
    clearJumpLock();
    return false;
  }
  return true;
}

function startGracePeriod() {
  sessionStorage.setItem(LOGIN_GRACE_KEY, String(Date.now() + LOGIN_GRACE_MS));
}

function inGracePeriod() {
  const until = Number(sessionStorage.getItem(LOGIN_GRACE_KEY) || 0);
  if (!until) return false;
  if (Date.now() > until) {
    sessionStorage.removeItem(LOGIN_GRACE_KEY);
    return false;
  }
  return true;
}

/** setCookie 落在 index /#/ 后，跳回 operate.html / developer.html 等原页面 */
export function resumeAfterLogin() {
  if (sessionStorage.getItem(LOGIN_RESUME_FLAG) !== '1') return false;

  const saved = sessionStorage.getItem(LOGIN_RETURN_KEY);
  if (!saved) {
    sessionStorage.removeItem(LOGIN_RESUME_FLAG);
    clearJumpLock();
    startGracePeriod();
    return false;
  }

  sessionStorage.removeItem(LOGIN_RETURN_KEY);
  sessionStorage.removeItem(LOGIN_RESUME_FLAG);
  clearJumpLock();
  startGracePeriod();

  const target = saved.startsWith('/') ? saved : `/${saved}`;
  const current = `${location.pathname}${location.hash || ''}`;
  if (current === target) {
    return false;
  }

  location.replace(target);
  return true;
}

let passport;
function buildLoginUrl() {
  return `${passport}?appid=121997&source=121997&role=423&redirectUrl=${buildPassportRedirectUrl()}`;
}

if (env === 'online') {
  passport = 'https://passport.didichuxing.com/common/pc-login/2.0.0/index.html';
} else if (env === 'pre') {
  passport = 'https://passport.didichuxing.com/common/pc-login/2.0.0/index.html';
} else {
  passport = 'http://passport-test.didichuxing.com/static/pc-login/2.0.0/index.html';
}

/**
 * 供 window.Login / location.href = Login() 使用。
 * 方案 B：可自动跳；全局防抖，避免 MF 下 Host+Remote 抢跳。
 * 已在跳转中或回跳宽限期内时返回 location.href，使二次赋值变成空操作。
 */
export const login = () => {
  if (hasActiveJumpLock() || inGracePeriod()) {
    return location.href;
  }
  sessionStorage.setItem(LOGIN_JUMP_LOCK, '1');
  sessionStorage.setItem(LOGIN_JUMP_LOCK_AT, String(Date.now()));
  return buildLoginUrl();
};

export const logout = () => {
  clearJumpLock();
  sessionStorage.removeItem(LOGIN_GRACE_KEY);
  return `${passport}?appid=121997&source=121997&role=423&redirectUrl=${buildPassportRedirectUrl()}#/logout`;
};
